module.exports = __webpack_public_path__ + "assets/img/principleImgCN.30a5128b.png";